var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Image } from 'src/ui/components/Image/Image';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './avatar.module.scss';
export var Avatar = function (props) {
    var src = props.src, nbDocument = props.nbDocument;
    var _a = useState(null), avatarSrc = _a[0], setAvatarSrc = _a[1];
    var _b = useState(null), errorWhileLoaded = _b[0], setErrorWhileLoaded = _b[1];
    var nbDocParsed = nbDocument > 9 ? "9+" : nbDocument;
    useEffect(function () {
        if (src) {
            Promise.resolve(src)
                .then(function (result) {
                setErrorWhileLoaded(false);
                setAvatarSrc(result);
            })
                .catch(function () { return setErrorWhileLoaded(true); });
        }
    }, [src]);
    return (_jsxs("div", __assign({ className: styles.avatarWrapper }, { children: [!errorWhileLoaded && src ? (_jsx(Image, { src: avatarSrc, alt: '', onError: function () { return setErrorWhileLoaded(true); }, className: styles.avatarImage })) : (_jsx(Icons, { icon: E_ICONS.PICTURE, className: styles.avatarPlaceholder, color: COLORS.WHITE })), !!nbDocument && _jsx("p", { children: nbDocParsed })] })));
};
